import { roomAmenities, rooms } from '@/mocks/rooms';

export default function RoomsSection() {
  const scrollToBooking = () => {
    const el = document.getElementById('booking');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="sobe" className="relative bg-background-100 py-16 md:py-24 lg:py-28">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-16">
            <p className="font-label text-xs tracking-extra-wide text-accent-600 font-medium uppercase mb-3">
              NAŠE SOBE
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light text-foreground-950 mb-4">
              Izberi svojo sobo
            </h2>
            <p className="font-body text-sm md:text-base text-foreground-600 max-w-lg mx-auto leading-relaxed">
              Tri različne velikosti sob – od dvoposteljne do družinske štiriposteljne.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {rooms.map((room) => (
              <article
                key={room.id}
                className="room-card group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden flex flex-col transition-all duration-300 hover:border-accent-300/60"
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                  <img
                    src={room.image}
                    alt={room.name}
                    title={`${room.name} – Gostilna Marta`}
                    className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                  />
                  <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-950/75 backdrop-blur-sm text-white font-label text-[10px] tracking-wide uppercase">
                    <i className="ri-ruler-2-line text-accent-400"></i>
                    {room.size}
                  </span>
                  <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500 text-background-950 font-label text-[10px] font-semibold tracking-wide uppercase">
                    <i className="ri-user-line"></i>
                    {room.capacity}
                  </span>
                </div>

                <div className="p-6 md:p-7 flex flex-col flex-1">
                  <h3 className="font-heading text-xl md:text-2xl font-medium text-foreground-950 mb-2">
                    {room.name}
                  </h3>

                  <div className="flex items-center gap-2 font-label text-[11px] tracking-wide text-foreground-600 mb-3">
                    <i className="ri-hotel-bed-line text-accent-600"></i>
                    {room.beds}
                  </div>

                  <p className="font-body text-sm text-foreground-600 leading-relaxed mb-5">
                    {room.description}
                  </p>

                  <div className="mb-6">
                    <p className="font-label text-[10px] tracking-extra-wide uppercase text-foreground-500 mb-3">
                      Oprema
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {roomAmenities.map((item) => (
                        <span
                          key={item}
                          className="inline-flex items-center px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 font-label text-[10px] tracking-wide"
                        >
                          {item}
                        </span>
                      ))}
                    </div>
                  </div>

                  <button
                    onClick={scrollToBooking}
                    className="mt-auto inline-flex items-center justify-center gap-2 w-full px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 text-xs font-label font-semibold tracking-extra-wide transition-all duration-300 whitespace-nowrap cursor-pointer rounded-sm"
                  >
                    <i className="ri-calendar-check-line"></i>
                    REZERVIRAJ
                  </button>
                </div>
              </article>
            ))}
          </div>

          <p className="font-body text-xs md:text-sm text-foreground-500 text-center mt-10 md:mt-12">
            Cene in razpoložljivost preveri prek rezervacije ali po telefonu.
          </p>
        </div>
      </div>
    </section>
  );
}